import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "divider" }, null, -1)
const _hoisted_3 = { class: "standard" }
const _hoisted_4 = ["checked"]
const _hoisted_5 = { class: "standard" }
const _hoisted_6 = ["checked"]
const _hoisted_7 = { class: "standard" }
const _hoisted_8 = ["checked"]
const _hoisted_9 = { class: "center-wrapper mobile-nav" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EasyDrop = _resolveComponent("EasyDrop")!
  const _component_Datepicker = _resolveComponent("Datepicker")!

  return (_openBlock(), _createBlock(_component_EasyDrop, {
    customClasses: 'datepicker',
    isFullMobile: true,
    hasTopTip: true,
    customButtonClasses: 'easy-icon-calendar main-drop search-btn',
    buttonId: 'searchDatepickerBtn',
    onOpenedOnce: _ctx.handleDate,
    ref: "easyDrop"
  }, {
    buttonText: _withCtx(() => [
      (_ctx.hasDate)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode(_toDisplayString(_ctx.formatShortDate(_ctx.date[0])) + " - " + _toDisplayString(_ctx.formatShortDate(_ctx.date[1])), 1)
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode(_toDisplayString(_ctx.pageTexts['searchbarDateLabelChooseDate']), 1)
          ], 64))
    ]),
    contentHeader: _withCtx(() => [
      (_ctx.pageTexts['searchbarDateInfoPopup'])
        ? (_openBlock(), _createBlock(_component_EasyDrop, {
            key: 0,
            dropdownType: 'tooltip',
            position: 'right'
          }, {
            content: _withCtx(() => [
              _createElementVNode("div", {
                class: "rte",
                innerHTML: _ctx.pageTexts['searchbarDateInfoPopup']
              }, null, 8, _hoisted_1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createElementVNode("p", null, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.pageTexts['searchbarDateHeadline']), 1),
        _createTextVNode(" " + _toDisplayString(_ctx.pageTexts['searchbarDateSubheadline']), 1)
      ])
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_Datepicker, {
          modelValue: _ctx.date,
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = ($event: any) => ((_ctx.date) = $event)),
            _ctx.handleDate
          ],
          "format-locale": _ctx.formatLocale,
          locale: _ctx.localeStrings.name,
          format: "P",
          range: "",
          multiCalendars: "",
          monthNameFormat: "long",
          weekNumbers: "",
          weekNumName: "",
          dayNames: _ctx.weekDays,
          autoApply: "",
          closeOnAutoApply: false,
          enableTimePicker: false,
          minDate: new Date(),
          preventMinMaxNavigation: "",
          hideOffsetDates: "",
          inline: ""
        }, null, 8, ["modelValue", "format-locale", "locale", "dayNames", "minDate", "onUpdate:modelValue"])
      ]),
      _hoisted_2
    ]),
    contentFooter: _withCtx(() => [
      _createElementVNode("div", null, [
        _createTextVNode(_toDisplayString(_ctx.pageTexts['searchbarDateLabelDeparture']) + "  ", 1),
        _createElementVNode("strong", null, _toDisplayString(_ctx.formatLongDate(_ctx.date[0])), 1),
        (_ctx.showFlexibleDate)
          ? (_openBlock(), _createBlock(_component_EasyDrop, {
              key: 0,
              dropdownType: 'select'
            }, {
              buttonText: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.flexDayButtonText), 1)
              ]),
              content: _withCtx(() => [
                _createElementVNode("fieldset", null, [
                  _createElementVNode("label", _hoisted_3, [
                    _createElementVNode("input", {
                      type: "radio",
                      name: "dateOptions",
                      value: "0",
                      checked: _ctx.flexDate === 0,
                      onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateFlexDate(0)))
                    }, null, 40, _hoisted_4),
                    _createElementVNode("span", null, _toDisplayString(_ctx.pageTexts['searchbarDateLabelExactDate']), 1)
                  ]),
                  _createElementVNode("label", _hoisted_5, [
                    _createElementVNode("input", {
                      type: "radio",
                      name: "dateOptions",
                      value: "1",
                      checked: _ctx.flexDate === 1,
                      onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateFlexDate(1)))
                    }, null, 40, _hoisted_6),
                    _createElementVNode("span", null, "+/- 1 " + _toDisplayString(_ctx.pageTexts['searchbarDateLabelDay']), 1)
                  ]),
                  _createElementVNode("label", _hoisted_7, [
                    _createElementVNode("input", {
                      type: "radio",
                      name: "dateOptions",
                      value: "2",
                      checked: _ctx.flexDate === 2,
                      onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateFlexDate(2)))
                    }, null, 40, _hoisted_8),
                    _createElementVNode("span", null, "+/- 2 " + _toDisplayString(_ctx.pageTexts['searchbarDateLabelDays']), 1)
                  ])
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", null, [
        _createTextVNode(_toDisplayString(_ctx.pageTexts['searchbarDateLabelArrival']) + "  ", 1),
        _createElementVNode("strong", null, _toDisplayString(_ctx.formatLongDate(_ctx.date[1])), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        (_ctx.isHotelApp)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "btn-primary",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.nextDrop && _ctx.nextDrop(...args)))
            }, _toDisplayString(_ctx.pageTexts['hotelPageNavigationButtonNext']), 1))
          : (_openBlock(), _createElementBlock("button", {
              key: 1,
              type: "button",
              class: "btn-primary",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.closeDropdown && _ctx.closeDropdown(...args)))
            }, _toDisplayString(_ctx.pageTexts['hotelPageGeneralNavigationButtonSave']), 1))
      ])
    ]),
    _: 1
  }, 8, ["onOpenedOnce"]))
}